import React from "react";
import styles from "./patientVoice.module.css";
import { Section, SectionIntro } from "../../../../COMPONENTS/UI";
import useCountUp from "../../../../UTILS/HOOKS/useCountUp";
import { patientVoice } from "../../../../CONTENT/physicians";

const Stat = ({ value, text }) => {
  const [count, ref] = useCountUp(value);
  return (
    <li className={styles.stat} ref={ref}>
      <p className={styles.value}>
        <span aria-hidden="true">{count}%</span>
        <span className={styles.srOnly}>{value}%</span>
      </p>
      <p className={styles.text}>{text}</p>
    </li>
  );
};

const PatientVoice = () => (
  <Section tone="ink" id="patients-say" labelledBy="patients-say-title">
    <SectionIntro
      id="patients-say-title"
      eyebrow="Your patients are ready"
      title="Patients want their physician to ask."
    />
    <ul className={styles.list}>
      {patientVoice.map((s) => (
        <Stat key={s.text} {...s} />
      ))}
    </ul>
  </Section>
);

export default PatientVoice;
